import FJUndoStore from "../../store/FJUndoStore";
import {FJMediaAction, FJPreviewAction, FJTimeLineAction, FJToolbarAction, FJWatermarkAction} from "./FJRoot.action";
import FJCanvasStore from "../../store/FJCanvasStore";
import FJActionConstant from "../../constant/FJActionConstant";
// import FJEvent from "../../core/FJEvent";
import FJEventConstant from "../../constant/FJEventConstant";
import FJProjectAction from "./FJProject.action";
import FJMoreAction from "./FJMore.action";
import FJCoreUtil from "../../core/util/FJCoreUtil";

let FJUndoAction = (function () {

  return {

    /**
     * @description 触发undo
     */
    undoAction: function () {
      return (dispatch) => {
        if (FJUndoStore.hasUndo()) {
          dispatch(FJPreviewAction.setVideoPauseAction());

          // 这里graphId、state分开获取的目的是达到数据变化过程中的操作对象，而不是数据记录时的操作对象
          let {graphId} = FJUndoStore.get();
          FJUndoStore.undo();
          let {state} = FJUndoStore.get();
          dispatch(this.updateViewAfterUndoRedoAction(graphId, state));
        }
      };
    },

    /**
     * @description 触发redo
     */
    redoAction: function () {
      return (dispatch) => {
        if (FJUndoStore.hasRedo()) {
          dispatch(FJPreviewAction.setVideoPauseAction());
          FJUndoStore.redo();
          let {graphId, state} = FJUndoStore.get();
          dispatch(this.updateViewAfterUndoRedoAction(graphId, state));
        }
      };
    },

    /**
     * @description undo-redo操作后更新界面
     * @param graphId
     * @param state
     */
    updateViewAfterUndoRedoAction: function (graphId, state) {
      return (dispatch) => {
        let {
          DECODE_CANVAS,
          RE_SEEK_AND_RENDER,
          SAVE_FOR_ONLINE,
          GET_CURRENT_TIME,
        } = FJCanvasStore.command;
        let hasInvalidUrl = !!state.graphs.find((graph) => !graph.url);
        FJCanvasStore.executeSync(DECODE_CANVAS, state);
        FJCanvasStore.executeSync(SAVE_FOR_ONLINE, false);

        if (hasInvalidUrl) {
          dispatch(FJProjectAction.updateGraphsUrlAction());
        }

        dispatch(FJTimeLineAction.updateAllTimelineAction());
        dispatch(FJTimeLineAction.updateDurationAction());

        if (graphId) {
          dispatch(FJTimeLineAction.selectTimeLineAction(graphId));
          dispatch(FJMediaAction.jumpToSelectedStartAction());
        } else {
          dispatch(FJTimeLineAction.selectTimeLineAction(-1));
        }

        dispatch(FJTimeLineAction.updateCopyStatusAction());
        dispatch(FJTimeLineAction.updatePasteStatusAction());
        dispatch(FJTimeLineAction.updateSplitStatusAction());

        dispatch(FJMoreAction.updateRatioTypeFromCoreAction());

        dispatch(FJToolbarAction.updateToolbarAction());
        dispatch(FJWatermarkAction.updateWatermarkAction());
        dispatch(FJTimeLineAction.checkIsShowTimeLimitModalAction());
        dispatch(FJPreviewAction.setVideoCurrentTimeAction(FJCanvasStore.executeSync(GET_CURRENT_TIME)));
        window.FJEvent.dispatch(FJEventConstant.AUTO_POSITION_SELECTED_TIMELINE);

        // widget在undo/redo时element挂载会判断父级不存在导致失败
        // TODO 调整widget渲染，去掉这里的特殊处理
        FJCoreUtil.wait(50).then(() => FJCanvasStore.execute(RE_SEEK_AND_RENDER)).catch((e) => {
          console.log(e)
        })
      };
    },

    /**
     * @description 更新undo-redo状态
     * @return {{hasRedo: (FJUndoStore.hasRedo|boolean), hasUndo: (FJUndoStore.hasUndo|boolean), type: string}}
     */
    updateUndoRedoAction: function () {
      return {
        type: FJActionConstant.UPDATE_UNDO_REDO,
        hasUndo: FJUndoStore.hasUndo(),
        hasRedo: FJUndoStore.hasRedo(),
      }
    }
  }
})();

export default FJUndoAction;
